import {useCallback} from 'react';

import {useCommonDataHook} from 'src/hooks/use-common-data-hook';
import {getWelcomeEmailCustomizations} from 'src/openapi/admin/apis/GetWelcomeEmailCustomizationsApi';
import {saveWelcomeEmailCustomizations} from 'src/openapi/admin/apis/SaveWelcomeEmailCustomizationsApi';
import {useAppDispatch} from 'src/store/hooks';

import type {WelcomeEmailCustomization} from 'src/openapi/admin/models/WelcomeEmailCustomization';

const INITIAL_CUSTOMIZATIONS: WelcomeEmailCustomization = {
    llmOnlyWelcomeEmailResourceLink: null,
    defaultLlmOnlyWelcomeEmailResourceLink: '',
};

export const useWelcomeEmailCustomizations = ({accountId}: {accountId: number}) => {
    const dispatch = useAppDispatch();

    const getDispatchAction = useCallback((signal: AbortSignal) => dispatch(
        getWelcomeEmailCustomizations({accountId}, {signal}),
    ), [accountId, dispatch]);

    const saveDispatchAction = useCallback((data: WelcomeEmailCustomization, signal: AbortSignal) => dispatch(
        saveWelcomeEmailCustomizations({
            accountId,
            welcomeEmailCustomizationSaveRequest: {
                llmOnlyWelcomeEmailResourceLink: data.llmOnlyWelcomeEmailResourceLink,
            },
        }, {signal}),
    ), [accountId, dispatch]);

    return useCommonDataHook({
        getDispatchAction,
        saveDispatchAction,
        initValue: INITIAL_CUSTOMIZATIONS,
    });
};
